import { ref } from 'vue';
import type { IntegrationListItem } from '@/services/api/integrations-api';

export type IntegrationsCacheState = {
  data: IntegrationListItem[];
  isUploaded: boolean;
};

export const createIntegrationsCacheModule = () => {
  const integrationsCache = ref<IntegrationsCacheState>({
    data: [],
    isUploaded: false,
  });

  const populateIntegrationsCache = (payload: IntegrationListItem[]) => {
    integrationsCache.value.data = payload;
    integrationsCache.value.isUploaded = true;
  };

  const updateIntegrationsCache = (payload: IntegrationListItem) => {
    integrationsCache.value.data = integrationsCache.value.data.map(item =>
      item.id === payload.id ? payload : item,
    );
  };

  const resetIntegrationsCache = () => {
    integrationsCache.value = {
      data: [],
      isUploaded: false,
    };
  };

  const reset = () => {
    resetIntegrationsCache();
  };

  return {
    state: {
      integrationsCache,
      populateIntegrationsCache,
      updateIntegrationsCache,
      resetIntegrationsCache,
    },
    reset,
  };
};
